import ModalResponsive from '@/components/commons/modal-responsive';
import { queryClient } from '@/lib/query-client';
import { truncateText } from '@/lib/utils';
import { StoreLocation } from '@/types/http';
import Cookies from 'js-cookie';
import { CheckIcon } from 'lucide-react';

interface ModalMultiOriginProps {
  openModal?: boolean;
  setOpenModal?: (open: boolean) => void;
  data: StoreLocation[];
}

export default function ModalMultiOrigin({ openModal, setOpenModal, data }: ModalMultiOriginProps) {
  const selectedLocationId = Cookies.get('_location_id');
  const selectedLocation = data.find((location) => location.location_id === selectedLocationId);

  const handleLocationSelect = (locationId: string) => {
    Cookies.set('_location_id', locationId, { expires: 7 });
    setOpenModal?.(false);
    queryClient.invalidateQueries({ queryKey: ['product-detail'] });
    queryClient.invalidateQueries({ queryKey: ['collection-list'] });
    queryClient.invalidateQueries({ queryKey: ['carts'] });
  };

  return (
    <ModalResponsive
      openModal={openModal}
      title='Multi Origin'
      setOpenModal={setOpenModal}
      className='max-w-xl'
    >
      <div className='max-h-[300px] overflow-y-scroll px-5 '>
        {data.map((value) => (
          <div
            className='my-3 flex cursor-pointer items-center justify-between rounded-md border border-slate-300 px-4 py-5'
            key={value.location_id}
            onClick={() => handleLocationSelect(value.location_id ?? '')}
          >
            <div className='flex flex-col'>
              <h1 className='text-sm'> {value.location_name}</h1>
              <p className='line-clamp-1'>{truncateText(value.location_address, 60)}</p>
            </div>

            {selectedLocation?.location_id === value.location_id && (
              <CheckIcon className='h-5 w-5 text-green-500' />
            )}
          </div>
        ))}
      </div>
    </ModalResponsive>
  );
}
